export default __webpack_public_path__ + "static/media/japantrad10.33fd3144.png";